import ScreenCurrencyFilterList from 'screens/CurrencyFilter/List';
import ScreenCurrencyFilterCreate from 'screens/CurrencyFilter/Create';
import ScreenCurrencyFilterUpdate from 'screens/CurrencyFilter/Update';
import { CURRENCY_FILTER } from './paths';

const currencyFilterRoutes = [
  {
    path: CURRENCY_FILTER.CREATE,
    name: 'CurrencyFilterCreate',
    component: ScreenCurrencyFilterCreate,
    allowPermissions: ['add_currencyfilter'],
  },
  {
    path: CURRENCY_FILTER.UPDATE,
    name: 'CurrencyFilterUpdate',
    component: ScreenCurrencyFilterUpdate,
    allowPermissions: ['change_currencyfilter'],
  },
  {
    path: CURRENCY_FILTER.LIST,
    name: 'CurrencyFilterList',
    component: ScreenCurrencyFilterList,
    allowPermissions: ['view_currencyfilter'],
  },
];

export default currencyFilterRoutes;
